import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

/**
 * A robust icon component that handles both component references and string names.
 * Ensures the app never crashes due to missing icons.
 */
const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = null;
  
  // Determine if we're looking for an icon by name string
  const potentialName = name || (typeof icon === 'string' ? icon : null);
  
  if (typeof icon === 'function' || (typeof icon === 'object' && icon !== null)) {
    // Already a component reference
    IconComponent = icon;
  } else if (potentialName) {
    // Look up by string (e.g., 'FiBell' or 'Bell')
    const lookupName = potentialName.startsWith('Fi') ? potentialName : `Fi${potentialName}`;
    IconComponent = FiIcons[lookupName];
  }

  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;